import * as yup from "yup";

export const orderSchema = yup
  .object({
    first_name: yup
      .string()
      .matches(/^[a-zA-Z\- ]{1,15}$/, "15 max, no special characters")
      .required("First name is required"),
    last_name: yup
      .string()
      .matches(/^[a-zA-Z\- ]{1,15}$/, "15 max, no special characters")
      .required("Second name is also required"),
    notes: yup.string().nullable(),
    price: yup.number().max(9999),
    quantity: yup.number().max(1000).required("Quantity is required"),
  })
  .required();
